export default __webpack_public_path__ + "static/media/005-nuggets.4fbb9b62.svg";